import PropTypes from 'prop-types';

import { IconDocument } from 'src/assets/icons/IconDocument';
import { IconMicrosoftDynamicsSales } from 'src/assets/icons/IconMicrosoftDynamicsSales';
import { IconSalesforce } from 'src/assets/icons/IconSalesforce';
import { MessagingBankIcon } from 'src/assets/icons/MessagingBank';
import { IconResourceImg } from 'src/assets/icons/ResourceImg';
import { IconResourceTypeAudio } from 'src/assets/icons/ResourceTypeAudio';
import { IconResourceTypeVideo } from 'src/assets/icons/ResourceTypeVideo';
import { IconResourceUrl } from 'src/assets/icons/ResourceUrl';

import { PROMPT_MENU_TYPE } from '../../lib';

const MENU_TYPE_ICONS = {
  [PROMPT_MENU_TYPE.url]: IconResourceUrl,
  [PROMPT_MENU_TYPE.bank]: MessagingBankIcon,
  [PROMPT_MENU_TYPE.image]: IconResourceImg,
  [PROMPT_MENU_TYPE.audio]: IconResourceTypeAudio,
  [PROMPT_MENU_TYPE.video]: IconResourceTypeVideo,
  [PROMPT_MENU_TYPE.document]: IconDocument,
  [PROMPT_MENU_TYPE.salesforce]: IconSalesforce,
  [PROMPT_MENU_TYPE.microsoftDynamicsSales]: IconMicrosoftDynamicsSales,
};

export const MenuTypeIcon = ({ className, menuType }) => {
  const Icon = MENU_TYPE_ICONS[menuType];
  if (!Icon) {
    return null;
  }

  return <Icon className={className} />;
};

MenuTypeIcon.propTypes = {
  className: PropTypes.string,
  menuType: PropTypes.oneOf(Object.values(PROMPT_MENU_TYPE)).isRequired,
};

MenuTypeIcon.defaultProps = {
  className: null,
};
